(function (global) {
  'use strict';

  var DEFAULT_MONEY_FORMAT = '${{amount}}';

  function isBlocked(totalCents, floorCents) {
    if (!floorCents) return false;
    return totalCents < floorCents;
  }

  function formatMoney(cents, format) {
    return (format || DEFAULT_MONEY_FORMAT).replace('{{amount}}', (cents / 100).toFixed(2));
  }

  function shortfallText(template, totalCents, floorCents, format) {
    if (!isBlocked(totalCents, floorCents)) return '';
    return String(template || '').replace('[amount]', formatMoney(floorCents - totalCents, format));
  }

  var api = { isBlocked: isBlocked, formatMoney: formatMoney, shortfallText: shortfallText };

  if (typeof HTMLElement !== 'undefined') {
    class ShamCartFloor extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('#checkout');
        this.notice = this.querySelector('[data-floor-notice]');
        this.shortfall = this.querySelector('[data-floor-shortfall]');
        this.floorCents = parseInt(this.dataset.floorCents, 10) || 0;
        if (!this.button || !this.notice) return;

        this.blocked = this.button.getAttribute('aria-disabled') === 'true';

        this.addEventListener('click', this.onClickCapture.bind(this), true);

        // PUB_SUB_EVENTS.cartUpdate is published nowhere in this theme:
        // assets/cart.js:409 is reachable only from updateQuantity, whose two
        // callers are the change handler (needs a data-index that /cart's
        // stepper has not got) and CartRemoveButton:55, which resolves
        // this.closest("cart-drawer-items") - an element never registered.
        // So the subscriber below is defensive only, and the live signal is
        // the bubble: /cart's stepper goes through jc-bundle-main.js
        // changeProductQuantity, which assigns window.cart from the
        // /cart/update.js response and then patches #cart-icon-bubble from
        // that same response, so a mutation there means the write has landed
        // and window.cart already holds the new authoritative total.
        this.bubble = document.getElementById('cart-icon-bubble');
        if (this.bubble) {
          this.lastCart = global.cart;
          this.observer = new MutationObserver(this.onCartMutation.bind(this));
          this.observer.observe(this.bubble, { childList: true, subtree: true, characterData: true });
        }

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            var total = event && event.cartData && event.cartData.total_price;
            if (typeof total === 'number') this.apply(total);
          });
        }
      }

      disconnectedCallback() {
        if (this.unsubscriber) this.unsubscriber();
        if (this.observer) this.observer.disconnect();
      }

      onCartMutation() {
        // Identity, not value: a stale re-read must not overwrite a fresh apply.
        if (global.cart === this.lastCart) return;
        this.lastCart = global.cart;
        var total = global.cart && global.cart.total_price;
        if (typeof total === 'number') this.apply(total);
      }

      onClickCapture(event) {
        if (!this.blocked) return;
        if (!event.target.closest || !event.target.closest('#checkout')) return;
        event.preventDefault();
        event.stopPropagation();
        this.notice.focus();
      }

      apply(totalCents) {
        this.blocked = isBlocked(totalCents, this.floorCents);
        this.button.setAttribute('aria-disabled', String(this.blocked));
        this.notice.hidden = !this.blocked;
        if (this.shortfall) {
          this.shortfall.textContent = shortfallText(
            this.dataset.shortfallText,
            totalCents,
            this.floorCents,
            global.jollyVariables && global.jollyVariables.money_format
          );
        }
      }
    }

    customElements.define('sham-cart-floor', ShamCartFloor);
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else global.ShamCartFloorRules = api;

})(typeof globalThis !== 'undefined' ? globalThis : this);
